import DriversTable from './DriversTable';
export default DriversTable;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DriversTable/index.js